import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Modal, InputGroup } from "react-bootstrap";
import LoadingSpinner from "../../Components/spinner";
import {
  deleteBadgeById,
  fetchPaginatedBadgesList,
  restoreBadge,
  searchBadges,
  toggleBadgeStatus,
} from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import AddEditBadgeModal from "./addEditBadgeModal";
import { toast } from "sonner";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import BSPagination from "../../Components/pagination";

const BadgesList = ({
  badges,
  setBadges,
  pagination,
  setPagination,
  granted,
}) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [filters, setFilters] = useState(3);
  const [filtering, setFiltering] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalOptions, setModalOptions] = useState({});
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [selectedBadge, setSelectedBadge] = useState({});
  const tableRef = useRef(null);

  // Fetch badges with optional filters
  const fetchBades = async (pagination, str = "") => {
    setFiltering(true);
    const res = await fetchPaginatedBadgesList(
      pagination.currentPage,
      pagination.pageSize,
      str
    );
    if (res?.data?.success && res?.data?.data) {
      setBadges(res.data.data);
      if (res.data.pagination) setPagination(res.data.pagination);
    } else {
      handleErrors(res, navigate);
    }
    setFiltering(false);
  };

  const columns = [
    { data: "name", title: "Name" },
    { data: "description", title: "Description" },
    { data: "badge_type", title: "Type" },
    { data: "requirements", title: "Requirement" },
    { data: "rank_value", title: "Rank Value" },
    { data: "status", title: "Status" },
    { data: "actions", title: "Actions" },
  ];

  // Filters logic
  const fetchFilteredBadges = async (e) => {
    setQuery("");
    setFilters(e.target.value);
    await fetchBades(pagination, `status=${e.target.value}`);
  };

  const handleAddEditBadge = (bdg) => {
    setSelectedBadge(bdg);
    setShowModal(true);
  };
  // Pagination
  const handlePageChange = async (page) => {
    const temp = { ...pagination, currentPage: page };
    setPagination(temp);
    const str = `status=${filters}`;
    fetchBades(temp, str);
  };

  // Search
  const handleSearch = async (e) => {
    const string = e.target.value;
    setQuery(string);
    if (string) {
      setFiltering(true);
      setFilters("3");
      const res = await searchBadges(string);
      if (res?.data?.data) {
        setBadges(res.data.data);
        if (res.data.pagination) setPagination(res.data.pagination);
      } else {
        handleErrors(res, navigate);
      }
      setFiltering(false);
    } else {
      const str = `status=${filters}`;
      fetchBades(pagination, str);
    }
  };

  // Change status
  const changeStatus = async (data) => {
    const res = await toggleBadgeStatus(data);
    if (res?.data?.success) {
      const str = `status=${filters}`;
      await fetchBades(pagination, str);
      toast.info("Badge status has been updated!", {
        duration: 2000,
      });
      setShowOptionsModal(false);
    } else {
      handleErrors(res, navigate);
    }
  };

  // Delete badge
  const deleteBadge = async (data) => {
    if (!data.id) return;
    const res = await deleteBadgeById(data.id);
    if (res?.data?.success) {
      const str = `status=${filters}`;
      await fetchBades(pagination, str);
      toast.info("Badeg record has been deleted!", {
        duration: 2000,
      });
      setShowOptionsModal(false);
    } else {
      handleErrors(res, navigate);
    }
  };

  // // // Restore Badge
  const restoreBadgeById = async (data) => {
    if (!data.id) return;
    const res = await restoreBadge(data.id);
    if (res?.data?.success) {
      const str = `status=${filters}`;
      await fetchBades(pagination, str);
      toast.info("Badge record has been restored!", {
        duration: 2000,
      });
      setShowOptionsModal(false);
    } else {
      handleErrors(res, navigate);
    }
  };

  const promptAction = (header, body, method, data) => {
    setModalOptions({
      header,
      body,
      method,
      data,
      okay: header.includes("Delete") ? "Delete" : "Change",
    });
    setShowOptionsModal(true);
  };

  useEffect(() => {
    if (!tableRef.current) return;

    const rows = badges.map((bdg) => ({
      name: bdg.name || "",
      description: bdg.description || "",
      badge_type:bdg.badge_type,
      requirements:bdg?.requirements?`${bdg.requirements.split(">=")[1]} Ads`:"",
      rank_value: bdg.rank_value || "",
      status: `
        <button class=\"btn btn-sm status-btn ${bdg.status === 1 ? "text-success" : "text-danger"}\" data-id=\"${bdg.id}\" title="change status">${bdg.status === 1 ? "Active" : "Inactive"}</button>`,
      actions:
        filters === "2"
          ? `
        <button class=\"btn btn-outline-danger btn-sm restore-btn me-1\" data-id=\"${bdg.id}\" title="restore"><i class="fa-solid fa-rotate-right"></i></button>`
          : `${granted?.some((perm) => perm.type === "update") ? `<button class=\"btn btn-outline-primary btn-sm edit-btn me-1\" data-id=\"${bdg.id}\" title="edit"><i class=\"fas fa-edit\"></i></button>` : ""}` +
            (bdg?.status === 0 &&
            granted?.some((perm) => perm.type === "delete")
              ? `<button class=\"btn btn-outline-danger btn-sm delete-btn\" data-id=\"${bdg.id}\" title="delete"><i class=\"fas fa-trash\"></i></button>`
              : ""),
    }));

    const config = {
      data: rows,
      columns,
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };
    const $tbl = $(tableRef.current);

    if ($.fn.dataTable.isDataTable($tbl)) {
      $tbl.DataTable().clear().rows.add(rows).draw();
    } else {
      $tbl.DataTable(config);
    }

    // Correctly unbind all handlers
    $tbl.off("click", ".status-btn, .view-btn, .edit-btn, .delete-btn");

    // Bind handlers with guard
    $tbl.on("click", ".status-btn", function () {
      const id = $(this).data("id");
      const bdg = badges.find((b) => b.id === id);
      if (!bdg) return;
      if (bdg?.deletedAt === null) {
        promptAction(
          "Change Status",
          `Are you sure you want to change status of \"${bdg.name}\"?`,
          changeStatus,
          { id: bdg.id, status: bdg.status === 1 ? 0 : 1 }
        );
      } else {
        toast.info("Cannot change status of a deleted record!", {
          duration: 2000,
        });
      }
    });

    $tbl.on("click", ".view-btn", function () {
      const id = $(this).data("id");
      const bdg = badges.find((b) => b.id === id);
      if (!bdg) return;
      setSelectedBadge(bdg);
      setShowModal(true);
    });

    $tbl.on("click", ".edit-btn", function () {
      const id = $(this).data("id");
      const bdg = badges.find((b) => b.id === id);
      if (!bdg) return;
      setSelectedBadge(bdg);
      setShowModal(true);
    });

    $tbl.on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      const bdg = badges.find((b) => b.id === id);
      if (!bdg) return;
      promptAction(
        "Delete Badge",
        `Are you sure you want to delete \"${bdg.name}\"?`,
        deleteBadge,
        { id: bdg.id }
      );
    });

    $tbl.on("click", ".restore-btn", function () {
      const id = $(this).data("id");
      const bdg = badges.find((b) => b.id === id);
      if (!bdg) return;
      promptAction(
        "Restore Badge",
        `Are you sure you want to restore \"${bdg.name}\"?`,
        restoreBadgeById,
        { id: bdg.id }
      );
    });

    return () => {
      if ($.fn.dataTable.isDataTable($tbl)) $tbl.DataTable().destroy();
    };
  }, [badges]);

  return (
    <div
      className="container py-4 bg-dark text-light rounded mb-4"
      data-testid="badges-list"
    >
      <div className="row align-items-center mb-4">
        <div className="col-md-8 row">
          <div className="col-md-5">
            <Form.Control
              type="text"
              placeholder="Search Badges..."
              value={query}
              onChange={handleSearch}
              className="bg-dark text-light border-light"
            />
          </div>
          <div className="col-md-5">
            <InputGroup>
              <Form.Select
                value={filters}
                onChange={fetchFilteredBadges}
                className="bg-dark text-light border-light"
              >
                <option value="3">All</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
                <option value="2">Deleted</option>
              </Form.Select>
            </InputGroup>
          </div>
          <div className="col-md-1 text-end">
            {filtering ? (
              <LoadingSpinner size="md" />
            ) : (
              <Button
                onClick={() => {
                  setFilters("3");
                  const str = "status=3";
                  fetchBades(pagination, str);
                }}
                className="btn-success"
                title="Reset filters and refresh records"
              >
                Reset
              </Button>
            )}
          </div>
        </div>
        <div className="col-md-4 text-end">
          {granted?.some((perm) => perm.type === "create") && (
            <Button
              onClick={() => {
                handleAddEditBadge({});
              }}
              className="btn-success"
              title="Add new badge"
            >
              <i className="bi bi-plus-circle"></i> Add New Badge
            </Button>
          )}
        </div>
      </div>
      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table table-striped table-dark"
          data-testid="table"
        />
        <div className="d-flex justify-content-end mt-3">
          <div className="mx-4 py-2">
            <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
          </div>
          <BSPagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={handlePageChange}
            showFirstLast
            siblingCount={2}
          />
        </div>
      </div>

      <AddEditBadgeModal
        showModal={showModal}
        setShowModal={setShowModal}
        selectedBadge={selectedBadge}
        setSelectedBadge={setSelectedBadge}
        fetchBades={fetchBades}
        pagination={pagination}
      />
      <Modal
        show={showOptionsModal}
        onHide={() => setShowOptionsModal(false)}
        centered
        data-testid="modal"
      >
        <Modal.Header closeButton className="bg-dark text-light">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light">
          <Button
            variant="secondary"
            onClick={() => setShowOptionsModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => modalOptions.method(modalOptions.data)}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BadgesList;
